import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import parseHtml from "html-react-parser";
import { Header2 } from "./Header.jsx";
import Header from "./Header.jsx";
import { useNavigate } from "react-router-dom";
import {
  API_URL,
  API_URL_SAVE_ANSWER,
  PENGAWAS_API_URL,
  API_URL_PHOTO,
  API_URL_LOG,
  SECRET_SESSION,
  BUILD_VERSION,
} from "../constants.js";
import CountdownTimer from "./shares/CountdownTimer.js";
import { FaCheck } from "react-icons/fa";
import ConfirmationModal from "./shares/ConfirmationModal.js";
import NoCopyText from "./shares/NoCopyText.js";
import { decrypt, decrypt_res, encrypt_res } from "./shares/GlobalFunction.jsx";
import AlertModal from "./shares/AlertModal.js";
import PauseModal from "./shares/PauseModal.js";
import Toggle from "./shares/ToggleSwitch.js";
import moment from "moment-timezone";
import Loader from "./shares/Loader.jsx";
import NetError from "./NetworkError.jsx";
import AlertProgres from "./shares/AlertProgres.js";
import axiosInstance from "./shares/axiosConfig.js";
import MessageModal from "./shares/MessageModal.js";

import {
  PiAppWindow,
  PiCaretLeftBold,
  PiCaretRightBold,
  PiClock,
  PiGridFour,
  PiGridNine,
  PiMagnifyingGlassMinus,
  PiMagnifyingGlassPlus,
} from "react-icons/pi";
import {
  ACCESS_STATUS_CONFIG,
  checkAccessStatus,
  checkPesanPengawas,
  registerFCMToken,
  initializeNotificationSystem,
} from '../utils/testNotificationUtils';
import Loading from "./shares/Loading.jsx";
import InfoStatusJawab from "./shares/InfoStatusJawab.jsx";

function ProsesTestReguler() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  const [isLoading, setIsLoading] = React.useState(true);
  const [effectsCompleted, setEffectsCompleted] = React.useState(0);
  const [isMessageModalOpen, setModalMessageOpen] = useState(false);
  const [pesanPengawas, setPesanPengawas] = useState("");
  const [timeStamp, setTimeStamp] = useState("");
  const navigate = useNavigate();
  const timerRef = useRef();
  const [starTimer, setStarTimer] = useState("start");
  const [currentPage, setCurrentPage] = useState(0); // 0 = halaman pertama
  const itemsPerPage = 3;

  const [isVisibleNavigasiSoal, setIsVisibleNavigasiSoal] = useState(true);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isPauseModalOpen, setPauseModalOpen] = useState(false);
  const [isStopModalOpen, setStopModalOpen] = useState(false);
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const [isAlertTimeModalOpen, setAlertTimeModalOpen] = useState(false);
  // const [isAlertTimeOutOpen, setAlertTimeOutOpen] = useState(false);
  const [isAlertProgresOpen, setAlertProgresOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);

  const captureImageIntervalRef = useRef([]);
  // Add a new ref to store the access status check interval
  const accessStatusCheckIntervalRef = useRef([]);

  // add a new ref to store the notification check interval
  const notificationCheckIntervalRef = useRef([]);

  // Add ref for general intervals
  const intervalRef = useRef([]);

  // Add ref for textarea autosave timer
  const textareaAutosaveTimerRef = useRef(null);

  // Add new state to track access status
  const [accessStatus, setAccessStatus] = useState(null);
  const [isBtnNavigasiEnabled, setIsBtnNavigasiEnabled] = React.useState(false);
  const [dataProjek, setDataProjek] = useState(null);

  // Add state for FCM setup
  const [fcmInitialized, setFcmInitialized] = useState(false);

  // variable to handle stopModal
  const [catatanPengawas, setCatatan] = useState('');

  const [isAlertTimeOutOpen, setAlertTimeOutOpen] = useState(false);

  // Initialize userData at the top
  let userData = localStorage.getItem("user");
  let accessToken = localStorage.getItem("token");
  if (userData) {
    userData = JSON.parse(decrypt(userData));
  } else {
    navigate("/login");
  }
  let kamera = localStorage.getItem("kamera");

  // Initialize id_ujian at the top
  let id_ujian = localStorage.getItem("id_ujian");

  // init for debounce in isian singkat
  let debounce_timeout = null;

  // Function to clear all access status check timers
  const clearAccessStatusCheckTimers = () => {
    accessStatusCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    accessStatusCheckIntervalRef.current = [];
  };

  // function to clear all notification check timers
  const clearNotificationCheckTimers = () => {
    notificationCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    notificationCheckIntervalRef.current = [];
  }

  // Function to clear all timers
  const clearAllTimers = () => {
    // Clear general intervals
    intervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    intervalRef.current = [];
    
    // Clear access status check timers
    clearAccessStatusCheckTimers();
    
    // Clear notification check timers
    clearNotificationCheckTimers();

    // Clear textarea autosave timer
    if (textareaAutosaveTimerRef.current) {
      clearTimeout(textareaAutosaveTimerRef.current);
      textareaAutosaveTimerRef.current = null;
    }
  };

  // Initialize notification system
  const headerRef = useRef()
  React.useEffect(() => {
    // Notify Android that the candidate has entered an active exam session.
    // Android uses this to activate strict background detection (FR-024, FR-025).
    window.AndroidBridge?.notifyExamStarted();

    initializeNotificationSystem(
      userData,
      id_ujian,
      accessStatusCheckIntervalRef,
      notificationCheckIntervalRef,
      setAccessStatus,
      setCatatan,
      setStarTimer,
      setStopModalOpen,
      timerRef,
      navigate,
      setModalMessageOpen,
      setPesanPengawas,
      setTimeStamp,
      setFcmInitialized,
      setAlertTimeOutOpen,
      headerRef,
      captureImageIntervalRef,
      kamera
    );

    // Cleanup on component unmount
    return () => {
      clearAccessStatusCheckTimers(accessStatusCheckIntervalRef);
      clearNotificationCheckTimers(notificationCheckIntervalRef);
      
      // Clear textarea autosave timer
      if (textareaAutosaveTimerRef.current) {
        clearTimeout(textareaAutosaveTimerRef.current);
        textareaAutosaveTimerRef.current = null;
      }
    };
  }, [userData.id_projek, userData.id_siswa, userData.pengawas, id_ujian, navigate, headerRef]);

  React.useEffect(() => {
    if (effectsCompleted >= 3) {
      setIsLoading(false);
    }
  }, [effectsCompleted]);

  const [pesan, setPesan] = useState(
    "Tes Anda dihentikan sementara. Silahkan hubungi pengawas."
  );

  // React.useEffect(() => {
  //   const userId = userData.nopes;
  //   const eventSource = new EventSource(API_URL + `/events/${userId}`);

  //   eventSource.onmessage = (event) => {
  //     const data = JSON.parse(event.data);
  //     // console.log("Pesan dari server:", data.message);

  //     if (data.message === "LOGOUT") {
  //       // localStorage.setItem("countdown", "logout");
  //       setStarTimer("pause");
  //       timerRef.current.pause(); // Pause the timer
  //       // setPesan(data.detail);
  //       setStopModalOpen(true);

  //       //navigate("/peserta/logout");
  //     }

  //     if (data.message === "PAUSE_UJIAN") {
  //       // localStorage.setItem("countdown", "pause");
  //       // setStarTimer("pause");
  //       timerRef.current.pause(); // Pause the timer
  //       // setPesan(data.detail);
  //       // setPauseModalOpen(true);
  //     }

  //     if (data.message === "START_UJIAN") {
  //       // localStorage.setItem("countdown", "start");
  //       setPauseModalOpen(false);
  //       setStopModalOpen(false);
  //       timerRef.current.start(); // Start the timer
  //       setStarTimer("start");
  //     }
  //   };

  //   return () => {
  //     eventSource.close();
  //   };
  // }, [userData.nopes, navigate, timerRef]);

  let id_test = localStorage.getItem("mulai_ujian");
  if (id_test) {
    id_test = JSON.parse(decrypt(id_test));
    //get localStorage.setItem('statusTimeOut_'+id_projek_ujian, statusCheck.statusTimeOut);
  } else {
    navigate("/login");
  }

  React.useEffect(() => {
      const statusTimeOut = localStorage.getItem('statusTimeOut_'+userData.id_siswa+'_'+id_test);
      setAlertTimeOutOpen(statusTimeOut === "true" || statusTimeOut === true);
  }, [id_test]);

  let timestampNet = localStorage.getItem('ERR_NET');
  React.useEffect(() => {
    if (timestampNet && timerRef) {
      const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Proses Tes",
      sub_kategori: "Jaringan",
      remaining_time: 0,
      keterangan: `${userData.nopes} terkendala jaringan`,
      timeStamp: timestampNet / 1000
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    localStorage.removeItem('ERR_NET')
    }
  }, [timestampNet])



  const [post, setPost] = React.useState(null);

  React.useEffect(() => {
    axios.post(API_URL + "/login/info").then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
    });
    setEffectsCompleted((prev) => prev + 1);
    axios.post(API_URL + "/peserta/info_projek", {
      id_projek: userData.id_projek
    }, {headers: {Authorization: `Bearer ${accessToken}`}})
    .then((response) => {
      setDataProjek(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    })
  }, []);

  const [Subtest, setSubtest] = React.useState(null);
  const [Subtest2, setSubtest2] = React.useState(null);
  const [DaftarSoal, setDaftarSoal] = React.useState(null);
  let initialStatus = [].fill("");
  const [statusJawaban, setStatusJawaban] = useState(initialStatus);
  const [statusSeen, setStatusSeen] = useState(initialStatus);
  const [idSoal, setIdSoal] = useState(initialStatus);
  const [waktuMengerjakan, setWaktuMengerjakan] = useState(initialStatus);
  const [statusSave, setStatusSave] = useState(initialStatus);
  const [startIndex, setStartIndex] = useState(currentPage * itemsPerPage);
  const [endIndex, setEndIndex] = useState(startIndex + itemsPerPage);
  const [currentSoalList, setCurrentSoalList] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

//   const goToNextPage = () => {
//   if (currentPage < totalPages - 1) {
//     const nextPage = currentPage + 1;
//     const newStartIndex = nextPage * itemsPerPage;
//     const newEndIndex = Math.min(newStartIndex + itemsPerPage, DaftarSoal.listSoal.length);

//     setCurrentPage(nextPage);
//     setStartIndex(newStartIndex);
//     setEndIndex(newEndIndex);
//     setCurrentSoalList(DaftarSoal.listSoal.slice(newStartIndex, newEndIndex));
//   }
// };

// const goToPreviousPage = () => {
//   if (currentPage > 0) {
//     const prevPage = currentPage - 1;
//     const newStartIndex = prevPage * itemsPerPage;
//     const newEndIndex = Math.min(newStartIndex + itemsPerPage, DaftarSoal.listSoal.length);

//     setCurrentPage(prevPage);
//     setStartIndex(newStartIndex);
//     setEndIndex(newEndIndex);
//     setCurrentSoalList(DaftarSoal.listSoal.slice(newStartIndex, newEndIndex));
//   }
// };


  React.useEffect(() => {
    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      username: userData.nopes,
      kode_akses: userData.kode_akses,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );

    axiosInstance
      .post(API_URL + "/peserta/subtest", {
        data: encryptedPayload,
      })
      .then((response) => {
        // alert(JSON.stringify(response));
        // console.log(response);
        let decResponse = JSON.parse(
          decrypt_res(response.data.data, SECRET_SESSION)
        );

        let detailTes = decResponse[0];

        // Check for access denied response
        if (detailTes.error_message) {
          alert(detailTes.error_message);
          navigate("/peserta/logout");
          return;
        }

        if (detailTes.tipe_tes === 2) {
          navigate(`/peserta/start_test2?username=${userData.username}&event=${decResponse.id_projek}`);
        }

        if (detailTes.tampil_daftar_soal === 0) {
          setIsVisibleNavigasiSoal(false);
        }

        if (isMobile){
          setIsVisibleNavigasiSoal(false);
        }

        setSubtest(detailTes);
        setSubtest2(detailTes);

        const payload = {
          id_projek: userData.id_projek,
          id_siswa: userData.id_siswa,
          id_projek_ujian: id_test,
          id_naskah: detailTes.id_naskah,
          kode_paket_soal: detailTes.id_paket_soal,
          id_ujian: id_ujian,
          timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        const encryptedPayload = encrypt_res(
          JSON.stringify(payload),
          SECRET_SESSION
        );

        axiosInstance
          .post(API_URL + "/peserta/daftarsoal", {
            data: encryptedPayload,
          })
          .then((response) => {
            response.data.data = JSON.parse(
              decrypt_res(response.data.data, SECRET_SESSION)
            );

            response.data.answer = JSON.parse(
              decrypt_res(response.data.answer, SECRET_SESSION)
            );

            setDaftarSoal(response.data.data);
            setTotalPages(Math.ceil(response.data.data.listSoal.length / itemsPerPage));
            setCurrentSoalList(response.data.data.listSoal.slice(startIndex, endIndex));

            let newStatusJawaban = [];
            let newIdSoal = [];
            let newWaktuMengerjakan = [];
            let newStatusSave = [];
            let newJenisSoal = [];
            let localStatusJawaban = localStorage.getItem("statusJawaban");
            let localStatusSave = localStorage.getItem("statusSave");
            let localIdSoal = localStorage.getItem("idSoal");
            let localWaktuMengerjakan =
              localStorage.getItem("waktuMengerjakan");

            if (localWaktuMengerjakan) {
              newWaktuMengerjakan = JSON.parse(
                localStorage.getItem("waktuMengerjakan")
              );
            } else {
              if (response.data.redis === 1) {
                newWaktuMengerjakan =
                  response.data.answer.waktuMengerjakan.split(",");

                localStorage.setItem(
                  "waktuMengerjakan",
                  JSON.stringify(newWaktuMengerjakan)
                );
              } else {
                response.data.answer.map((item) => {
                  //moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
                  newWaktuMengerjakan[item.no_soal - 1] = moment(
                    item.waktu_mengerjakan
                  ).format("YYYY-MM-DD HH:mm:ss");
                  return item;
                });

                localStorage.setItem(
                  "waktuMengerjakan",
                  JSON.stringify(newWaktuMengerjakan)
                );
              }
            }

            // if (localIdSoal) {
            //   newIdSoal = JSON.parse(localStorage.getItem("idSoal"));
            // } else {
            //   response.data.answer.map((item) => {
            //     newIdSoal[item.no_soal - 1] = item.id_soal;
            //     return item;
            //   });

            //   localStorage.setItem("idSoal", JSON.stringify(newIdSoal));
            // }

            // alert(JSON.stringify(response.data.data.listSoal));

            response.data.data.listSoal.map((item) => {
              newIdSoal[item.no_soal - 1] = parseInt(item.id_soal);
              return item;
            });
            localStorage.setItem("idSoal", JSON.stringify(newIdSoal));

            response.data.data.listSoal.map((item) => {
              newJenisSoal[item.no_soal - 1] = parseInt(item.jenis_soal);
              return item;
            });
            localStorage.setItem("jenisSoal", JSON.stringify(newJenisSoal));

            if (localStatusSave) {
              newStatusSave = JSON.parse(localStorage.getItem("statusSave"));
            }

            if (localStatusJawaban) {
              newStatusJawaban = JSON.parse(
                localStorage.getItem("statusJawaban")
              );
            } else {
              if (response.data.redis === 1) {
                let tmpJawaban1 = response.data.answer.statusJawaban.split(",");
                let tmpJawaban2 = response.data.answer.statusJawaban.split("||");

                newStatusJawaban = tmpJawaban1;
                if (tmpJawaban2.length > tmpJawaban1.length)
                  newStatusJawaban = tmpJawaban2;
                localStorage.setItem(
                  "statusJawaban",
                  JSON.stringify(newStatusJawaban)
                );
                if (newJenisSoal.includes(4)){
                  newStatusJawaban = tmpJawaban2;
                  localStorage.setItem(
                    "statusJawaban",
                    JSON.stringify(newStatusJawaban)
                  );
                }
              } else {
                response.data.answer.map((item) => {
                  if (parseInt(item.jenis_soal) === 1)
                    newStatusJawaban[item.no_soal - 1] = item.jawaban_pilihan;
                  else newStatusJawaban[item.no_soal - 1] = item.jawaban_essai;

                  // newIdSoal[item.no_soal - 1] = item.id_soal;
                  // newWaktuMengerjakan[item.no_soal - 1] = item.waktu_mengerjakan;

                  return item;
                });

                localStorage.setItem(
                  "statusJawaban",
                  JSON.stringify(newStatusJawaban)
                );
              }
            }

            if (newIdSoal) setIdSoal(newIdSoal);
            if (newWaktuMengerjakan) setWaktuMengerjakan(newWaktuMengerjakan);
            if (newStatusSave) setStatusSave(newStatusSave);

            //set ke radio dan chekbox
            if (newStatusJawaban) {
              setStatusJawaban(newStatusJawaban);
              const initialSelectedValues = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (newStatusJawaban[i] !== "") {
                  initialSelectedValues["jawaban" + i] = newStatusJawaban[i];
                }
              }
              setSelectedValues(initialSelectedValues);

              const initialSelectedCheckBoxValues = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (
                  typeof newStatusJawaban[i] === "string" &&
                  newStatusJawaban[i] !== ""
                ) {
                  initialSelectedCheckBoxValues["jawaban" + i] = new Set(
                    newStatusJawaban[i].split(";")
                  );
                }
              }
              setSelectedCheckBoxValues(initialSelectedCheckBoxValues);

              const initialSelected3Values = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (
                  typeof newStatusJawaban[i] === "string" &&
                  newStatusJawaban[i] !== ""
                ) {
                  let tmpJawaban = newStatusJawaban[i].split(";");
                  for (let j = 0; j < tmpJawaban.length; j++) {
                    let tmpOpsi = tmpJawaban[j].split("|");
                    initialSelected3Values[tmpOpsi[0]] = parseInt(tmpOpsi[1]);
                  }
                }
              }
              setSelected3Values(initialSelected3Values);
            }
            setEffectsCompleted((prev) => prev + 1);
          });
        setEffectsCompleted((prev) => prev + 1);
      });
  }, [id_test, id_ujian, navigate, userData.id_projek, userData.id_siswa]);
  const webcamRef = useRef(null);
  // const [capturedImage, setCapturedImage] = useState(null);

  // const capture = () => {
  //   if (webcamRef.current) {
  //     const imageSrc = webcamRef.current.getScreenshot({
  //       width: 640,
  //       height: 480,
  //     });
  //     // setCapturedImage(imageSrc);
  //     axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
  //       id_projek: userData.id_projek,
  //       id_siswa: userData.id_siswa,
  //       id_ujian: id_ujian,
  //       nopes: userData.nopes,
  //       image: imageSrc,
  //     });
  //   } else {
  //     console.error("Webcam reference is null");
  //   }
  // };

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [noSoal, setNoSoal] = useState(1);

  const handleNextTab = () => {
    // console.log(statusJawaban)
    // if (DaftarSoal.listSoal[activeTabIndex].jenis_soal == "5") {
    //   saveAnswerRedis();
    //   const response = JSON.parse(localStorage.getItem("statusJawaban"))
    //   const payload_log = {
    //     id_siswa: userData.id_siswa,
    //     nopes: userData.nopes,
    //     nama_siswa: userData.nama_siswa,
    //     id_projek: userData.id_projek,
    //     type: 'ans',
    //     url: window.location.href,
    //     kategori: "Proses Tes",
    //     sub_kategori: Subtest.nama_projek,
    //     remaining_time: timerRef.current.getCurrentSeconds,
    //     // keterangan: `${userData.nopes} menjawab soal nomor ${activeTabIndex + 1} dengan response ${response[activeTabIndex]}`,
    //     keterangan: `${userData.nopes} menjawab soal id ${DaftarSoal.listSoal[activeTabIndex].id_soal} nomor ${activeTabIndex + 1} dengan response ${response[activeTabIndex]}`,
    //     timeStamp: Math.floor(Date.now() / 1000)
    //   }
    //   const encryptedPayload_log = encrypt_res(
    //     JSON.stringify(payload_log),
    //     SECRET_SESSION
    //   );
    //   axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
    //     data: encryptedPayload_log
    //   })
    // }
    if (activeTabIndex < DaftarSoal.listSoal.length - 1) {
      let nextIndex = activeTabIndex + 1;
      let nextPage = Math.floor((nextIndex) / itemsPerPage);
      let startIndex = nextPage * itemsPerPage;
      let endIndex = Math.min((nextPage * itemsPerPage) + itemsPerPage, DaftarSoal.listSoal.length)

      setActiveTabIndex(nextIndex);
      setNoSoal(nextIndex + 1);

      setCurrentPage(nextPage);
      setStartIndex(startIndex);
      setEndIndex(endIndex);
      setCurrentSoalList(DaftarSoal.listSoal.slice(startIndex, endIndex));
    }

    setStatusSeen((prevStatusSeen) => {
      let newStatus = [...prevStatusSeen];
      newStatus[noSoal] = 1
      localStorage.setItem("statusSeen", JSON.stringify(newStatus));
      return newStatus;
    });

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      // kalau kosong maka fill dengan ?
      if (!newStatus[activeTabIndex + 1]){
        newStatus[activeTabIndex + 1] = "?";
      }
      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
      return newStatus;
    })
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Proses Tes",
      sub_kategori: "Navigasi Soal",
      remaining_time: timerRef.current.getCurrentSeconds,
      keterangan: `${userData.nopes} klik soal selanjutnya menuju nomor ${activeTabIndex + 2}`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
  };

  const handlePreviousTab = () => {
    // if (DaftarSoal.listSoal[activeTabIndex].jenis_soal == "5") {
    //   saveAnswerRedis();
    //   const response = JSON.parse(localStorage.getItem("statusJawaban"))
    //   const payload_log = {
    //     id_siswa: userData.id_siswa,
    //     nopes: userData.nopes,
    //     nama_siswa: userData.nama_siswa,
    //     id_projek: userData.id_projek,
    //     type: 'ans',
    //     url: window.location.href,
    //     kategori: "Proses Tes",
    //     sub_kategori: Subtest.nama_projek,
    //     remaining_time: timerRef.current.getCurrentSeconds,
    //     // keterangan: `${userData.nopes} menjawab soal nomor ${activeTabIndex + 1} dengan response ${response[activeTabIndex]}`,
    //     keterangan: `${userData.nopes} menjawab soal id ${DaftarSoal.listSoal[activeTabIndex].id_soal} nomor ${activeTabIndex + 1} dengan response ${response[activeTabIndex]}`,
    //     timeStamp: Math.floor(Date.now() / 1000)
    //   }
    //   const encryptedPayload_log = encrypt_res(
    //     JSON.stringify(payload_log),
    //     SECRET_SESSION
    //   );
    //   axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
    //     data: encryptedPayload_log
    //   })
    // }
    let nextIndex = activeTabIndex - 1;
    let nextPage = Math.floor((nextIndex) / itemsPerPage)
    let startIndex = nextPage * itemsPerPage;
    let endIndex = Math.min((nextPage * itemsPerPage) + itemsPerPage, DaftarSoal.listSoal.length)
    setActiveTabIndex(nextIndex);
    setNoSoal(nextIndex + 1);

    setCurrentPage(nextPage);
    setStartIndex(startIndex);
    setEndIndex(endIndex);
    setCurrentSoalList(DaftarSoal.listSoal.slice(startIndex, endIndex));

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      // kalau kosong maka fill dengan ?
      if (!newStatus[activeTabIndex - 1]){
        newStatus[activeTabIndex - 1] = "?";
      }
      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
      return newStatus;
    })
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Proses Tes",
      sub_kategori: "Navigasi Soal",
      remaining_time: timerRef.current.getCurrentSeconds,
      keterangan: `${userData.nopes} klik soal sebelumnya menuju nomor ${activeTabIndex}`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
  };

  const setTab = (index) => {
    // if (DaftarSoal.listSoal[activeTabIndex].jenis_soal == "5") {
    //   saveAnswerRedis();
    //   const response = JSON.parse(localStorage.getItem("statusJawaban"))
    //   const payload_log = {
    //     id_siswa: userData.id_siswa,
    //     nopes: userData.nopes,
    //     nama_siswa: userData.nama_siswa,
    //     id_projek: userData.id_projek,
    //     type: 'ans',
    //     url: window.location.href,
    //     kategori: "Proses Tes",
    //     sub_kategori: Subtest.nama_projek,
    //     remaining_time: timerRef.current.getCurrentSeconds,
    //     // keterangan: `${userData.nopes} menjawab soal nomor ${activeTabIndex + 1} dengan response ${response[activeTabIndex]}`,
    //     keterangan: `${userData.nopes} menjawab soal id ${DaftarSoal.listSoal[activeTabIndex].id_soal} nomor ${activeTabIndex + 1} dengan response ${response[activeTabIndex]}`,
    //     timeStamp: Math.floor(Date.now() / 1000)
    //   }
    //   const encryptedPayload_log = encrypt_res(
    //     JSON.stringify(payload_log),
    //     SECRET_SESSION
    //   );
    //   axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
    //     data: encryptedPayload_log
    //   })
    // }
    setActiveTabIndex(index);
    setNoSoal(index + 1);
    let nextPage = Math.floor((index) / itemsPerPage)
    let startIndex = nextPage * itemsPerPage;
    let endIndex = Math.min((nextPage * itemsPerPage) + itemsPerPage, DaftarSoal.listSoal.length);

    setCurrentPage(nextPage);
    setStartIndex(startIndex);
    setEndIndex(endIndex);
    setCurrentSoalList(DaftarSoal.listSoal.slice(startIndex, endIndex));

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      // kalau kosong maka fill dengan ?
      if (!newStatus[index]){
        newStatus[index] = "?";
      }
      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
      return newStatus;
    })
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Proses Tes",
      sub_kategori: "Navigasi Soal",
      remaining_time: timerRef.current.getCurrentSeconds,
      keterangan: `${userData.nopes} pindah soal menuju nomor ${index + 1}`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const [fontSize, setFontSize] = useState(18); // Initial font size in pixels

  const increaseFontSize = () => {
    setFontSize((prevSize) => prevSize + 2); // Increase font size by 2px
  };

  const decreaseFontSize = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 10)); // Decrease font size by 2px but not below 10px
  };

  const [countEmpty, setCountEmpty] = useState(0);
  const [sisaTunggu, setSisaTunggu] = useState(0);

  //getInfoSubtesFunction
  const getInfoSubtest =() => {
    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      username: userData.nopes,
      kode_akses: userData.kode_akses,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );
    axiosInstance
      .post(API_URL + "/peserta/subtest", {
        data: encryptedPayload,
      })
      .then((response) => {
        let decResponse = JSON.parse(
          decrypt_res(response.data.data, SECRET_SESSION)
        );

        let detailTes = decResponse[0];
        setSubtest2(detailTes);
        setEffectsCompleted((prev) => prev + 1);
      });
  }

  const handleFinishTest = () => {
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Proses Tes",
      sub_kategori: "Pindah Subtes",
      remaining_time: timerRef.current.getCurrentSeconds,
      keterangan: `${userData.nopes} klik tombol selesai subtest`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    const hasEmpty = statusJawaban.some(
      (item) => item === "" || item === null || item === undefined
    );
    //cek jumlah yang kosong di statusJawaban

    // Count the number of empty, null, or undefined items in statusJawaban
    let localJawban = localStorage.getItem("statusJawaban");
    let is_essay = localStorage.getItem("jenisSoal");

    
    if (localJawban) {
      if (is_essay.includes('4') || is_essay.includes('5')){
        localJawban = localJawban.split("||")
      }else {
        localJawban = localJawban.split(",")
      }

      var emptyCount = localJawban
      .map(item => {
        // ubah ke string supaya aman
        let clean = String(item)
          .replace(/[\[\]"]/g, "") // hapus [, ], "
          .trim();
        return clean;
      })
      .filter(
        (item) =>
          item === "" ||
          item.toLowerCase() === "null" ||
          item === undefined ||
          item === "?"
      ).length;
      setCountEmpty(emptyCount);
    }

    

    getInfoSubtest();

    let waktuTes = Subtest2.durasi_ujian * 60 - Subtest2.sisa_waktu;
    // setWaktuTes(Subtest.durasi_ujian * 60 - Subtest.sisa_waktu);
    // let requiredTime = 900;
    let requiredTime = parseInt(Subtest2.min_submit) * 60;
    // let requiredTime = 0 * 60;
    let tempSisaTunggu = ((requiredTime - waktuTes)/60).toFixed(0);
    setSisaTunggu(tempSisaTunggu);
    // alert(requiredTime);
    if (
      // ini kalau tidak lengkap jawabannya
      Subtest.harus_lengkap === 1 && (
      emptyCount > 0 ||
      hasEmpty ||
      statusJawaban.length === 0 ||
      statusJawaban.length < DaftarSoal.listSoal.length)
    ) {
      if (waktuTes < requiredTime) {
        setAlertTimeModalOpen(true);
        const payload_log = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Selesai Tes",
          sub_kategori: "Selesai Subtes",
          remaining_time: timerRef.current.getCurrentSeconds,
          keterangan: `${userData.nopes} belum bisa menyelesaikan subtest karena belum sampai minimal pengerjaan`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_log = encrypt_res(
          JSON.stringify(payload_log),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload_log
        })
        // handleOpenModal();
      } else {
        setAlertModalOpen(true);
      }
    } else {
      // jika masih kurang dari 15 menit tidak boleh submit
      if (waktuTes < requiredTime) {
        setAlertTimeModalOpen(true);
        const payload_log = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "Selesai Tes",
          sub_kategori: "Selesai Subtes",
          remaining_time: timerRef.current.getCurrentSeconds,
          keterangan: `${userData.nopes} belum bisa menyelesaikan subtest karena belum sampai minimal pengerjaan`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_log = encrypt_res(
          JSON.stringify(payload_log),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload_log
        })
        // handleOpenModal();
      } else {
        handleOpenModal();
      }
    }
  };

  // const [isModalOpen, setModalOpen] = useState(false);
  // const [isPauseModalOpen, setPauseModalOpen] = useState(false);
  // const [isStopModalOpen, setStopModalOpen] = useState(false);
  // const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  // const [isAlertProgresOpen, setAlertProgresOpen] = useState(false);
  // const [alertVisible, setAlertVisible] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleOpenModalTimeout = () => {
    if (!isAlertProgresOpen) {
      clearAllTimers();
      setAlertTimeOutOpen(true);
      const payload_log = {
        id_siswa: userData.id_siswa,
        nopes: userData.nopes,
        nama_siswa: userData.nama_siswa,
        id_projek: userData.id_projek,
        type: 'log',
        url: window.location.href,
        kategori: "Selesai Tes",
        sub_kategori: "Selesai Subtes",
        remaining_time: timerRef.current.getCurrentSeconds,
        keterangan: `${userData.nopes} kehabisan waktu pengerjaan sehingga muncul dialog selesai`,
        timeStamp: Math.floor(Date.now() / 1000)
      }
      const encryptedPayload_log = encrypt_res(
        JSON.stringify(payload_log),
        SECRET_SESSION
      );
      axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
        data: encryptedPayload_log
      })
    }
  };

  const handleConfirm = () => {
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Selesai Tes",
      sub_kategori: "Selesai Subtes",
      remaining_time: timerRef.current.getCurrentSeconds,
      keterangan: `${userData.nopes} klik tombol lanjutkan sehingga menyelesaikan ${Subtest.nama_projek}`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    clearAllTimers();
    setModalOpen(false);
    setAlertTimeOutOpen(false);
    setAlertProgresOpen(true);

    //set status ujian selesai
    let localStatusSave = localStorage.getItem("statusSave") || "[]";
    if (localStatusSave) {
      localStatusSave = JSON.parse(localStatusSave);
    }

    let localStatusJawaban = localStorage.getItem("statusJawaban") || "[]";
    if (localStatusJawaban) {
      localStatusJawaban = JSON.parse(localStatusJawaban);
    }

    let localWaktuMengerjakan =
      localStorage.getItem("waktuMengerjakan") || "[]";
    if (localWaktuMengerjakan) {
      localWaktuMengerjakan = JSON.parse(localWaktuMengerjakan);
    }

    let localIdSoal = localStorage.getItem("idSoal") || "[]";
    if (localIdSoal) {
      localIdSoal = JSON.parse(localIdSoal);
    }

    let localJenisSoal = localStorage.getItem("jenisSoal") || "[]";
    if (localJenisSoal) {
      localJenisSoal = JSON.parse(localJenisSoal);
    }
    
    let localStatusSeen = localStorage.getItem("statusSeen") || "[]";
    if (localStatusSeen) {
      localStatusSeen = JSON.parse(localStatusSeen);
    }
    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: parseInt(id_ujian),
      soal: localIdSoal.join(","),
      statusJawaban: localStatusJawaban.join("||"),
      waktuMengerjakan: localWaktuMengerjakan.join(","),
      statusSave: localStatusSave.join(","),
      jenisSoal: localJenisSoal.join(","),
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );

    if (Subtest.id_ukin){
      let localStatusJawaban = JSON.parse(localStorage.getItem("statusJawaban"));
      for (let i = 0; i < localStatusJawaban.length; i++){
        let payloadUkin = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'log',
          url: window.location.href,
          kategori: "UKIN",
          sub_kategori: Subtest.id_ukin,
          remaining_time: 0,
          keterangan: localStatusJawaban[i],
          timeStamp: Math.floor(Date.now() / 1000)
          // jawaban: localStatusJawaban[i],
          // kegiatan_id: Subtest.id_ukin,
          // ptk_id: 0,
          // id_ujian: id_ujian,
        }
        const encryptedPayloadUkin = encrypt_res(
          JSON.stringify(payloadUkin),
          SECRET_SESSION
        )
        // axiosInstance.post(API_URL + "/peserta/sentUkin", {data: encryptedPayloadUkin})
        // .then((response) => {
        // })
        axiosInstance.post(API_URL_LOG + "/peserta/sentUkin", {data: encryptedPayloadUkin})
        .then((response) => {
        })
      }
    }

    axiosInstance
      .post(API_URL_SAVE_ANSWER + "/peserta/autosave_jawaban", {
        data: encryptedPayload,
      })
      .then((res) => {
        if (res.status === 200) {
          const payload = {
            id_projek: userData.id_projek,
            id_siswa: userData.id_siswa,
            id_projek_ujian: id_test,
            id_ujian: id_ujian,
            id_naskah: Subtest.id_naskah,
            jawaban: "",
            nopes: userData.nopes,
            kode_akses: userData.kode_akses,
          };

          const encryptedPayload = encrypt_res(
            JSON.stringify(payload),
            SECRET_SESSION
          );

          axiosInstance
            .post(API_URL_SAVE_ANSWER + "/peserta/selesaites", {
              data: encryptedPayload,
            })
            .then((response) => {
              // alert(JSON.stringify(response.data.data));
              if (parseInt(response.data.data) === 1) {
                localStorage.removeItem("statusJawaban");
                localStorage.removeItem("mulai_ujian");
                localStorage.removeItem("id_ujian");
                navigate(`/peserta/confirmtoken?username=${userData.username}&event=${userData.id_projek}`);
              } else {
                localStorage.removeItem("statusJawaban");
                localStorage.removeItem("mulai_ujian");
                localStorage.removeItem("id_ujian");
                navigate(`/peserta/finish_test?username=${userData.username}&event=${userData.id_projek}`);
              }
              localStorage.removeItem("statusJawaban");
              localStorage.removeItem("tampilPertanyaan");
              localStorage.removeItem("tampilJawaban");
              localStorage.removeItem("soalAktif");
              localStorage.removeItem("canBack");
              localStorage.removeItem("waktuMengerjakan");
              localStorage.removeItem("idSoal");
              localStorage.removeItem("countdown");
              localStorage.removeItem("statusSave");
              localStorage.removeItem("jenisSoal");
              localStorage.removeItem('statusTimeOut_'+userData.id_siswa+'_'+id_test)

              if (dataProjek && dataProjek.kamera != 0) {
                let captureImage = headerRef.current.capture();
                if (captureImage){
                  const payload_capture = {
                    id_projek: userData.id_projek,
                    id_siswa: userData.id_siswa,
                    id_ujian: 0,
                    nopes: userData.nopes,
                    image: captureImage,
                    timeStamp: Math.floor(Date.now() / 1000)
                  }
                  const encryptedPayload_capture = encrypt_res(
                    JSON.stringify(payload_capture),
                    SECRET_SESSION
                  );
                  axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
                    data: encryptedPayload_capture
                  });
                } else{
                  const payload_log = {
                    id_siswa: userData.id_siswa,
                    nopes: userData.nopes,
                    nama_siswa: userData.nama_siswa,
                    id_projek: userData.id_projek,
                    type: 'log',
                    url: window.location.href,
                    kategori: "Proses Tes",
                    sub_kategori: "Pindah Subtes",
                    remaining_time: timerRef.current.getCurrentSeconds,
                    keterangan: `${userData.nopes} kamera gagal menangkap gambar peserta`,
                    timeStamp: Math.floor(Date.now() / 1000)
                  }
                  const encryptedPayload_log = encrypt_res(
                    JSON.stringify(payload_log),
                    SECRET_SESSION
                  );
                  axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
                    data: encryptedPayload_log
                  })
                }
              }

              // setAlertProgresOpen(false);
            });
        } else {
          setAlertProgresOpen(false);
          setAlertVisible(true);
        }
      });
  };

  const handleCancel = () => {
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'log',
      url: window.location.href,
      kategori: "Selesai Tes",
      sub_kategori: "Selesai Subtes",
      remaining_time: timerRef.current.getCurrentSeconds,
      keterangan: `${userData.nopes} menutup konfirmasi selesai subtest`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
    setModalOpen(false);
    setAlertModalOpen(false);
    setAlertTimeModalOpen(false);
  };

  const saveAnswerRedis = () => {
    let localStatusJawaban = localStorage.getItem("statusJawaban") || "[]";
    if (localStatusJawaban) {
      localStatusJawaban = JSON.parse(localStatusJawaban);
    }
    // console.log(DaftarSoal.listSoal);

    let localIdSoal = localStorage.getItem("idSoal") || "[]";
    if (localIdSoal) {
      localIdSoal = JSON.parse(localIdSoal);
    }

    let localWaktuMengerjakan =
      localStorage.getItem("waktuMengerjakan") || "[]";
    if (localWaktuMengerjakan) {
      localWaktuMengerjakan = JSON.parse(localWaktuMengerjakan);
    }
    let localJenisSoal = localStorage.getItem("jenisSoal") || "[]";
    if (localJenisSoal) {
      localJenisSoal = JSON.parse(localJenisSoal);
    }

    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: parseInt(id_ujian),
      jumlah_soal: DaftarSoal.listSoal.length,
      soal: localIdSoal.join(","),
      statusJawaban: localStatusJawaban.join("||"),
      jenisSoal: localJenisSoal.join(","),
      waktuMengerjakan: localWaktuMengerjakan.join(","),
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );

    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/save_jawaban_redis", {
      data: encryptedPayload,
    });
  };

  //Pilihan Ganda
  const [selectedValues, setSelectedValues] = useState({});
  const handleRadioChange = (event, group) => {
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [group]: event.target.value,
    }));
    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      newStatus[parseInt(group.replace("jawaban", ""))] = event.target.value;
      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
      return newStatus;
    });
    const waktu_mengerjakan = moment()
      .tz("Asia/Bangkok")
      .format("YYYY-MM-DD HH:mm:ss");
    setWaktuMengerjakan((prevWaktuMengerjakan) => {
      let newStatus = [...prevWaktuMengerjakan];
      newStatus[parseInt(group.replace("jawaban", ""))] = waktu_mengerjakan;
      localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
      return newStatus;
    });
    setIdSoal((prevIdSoal) => {
      let newStatus = [...prevIdSoal];
      newStatus[parseInt(group.replace("jawaban", ""))] = event.target.title;
      localStorage.setItem("idSoal", JSON.stringify(newStatus));
      return newStatus;
    });
    setStatusSave((prevStatusSave) => {
      let newStatus = [...prevStatusSave];
      newStatus[parseInt(group.replace("jawaban", ""))] = 0;
      localStorage.setItem("statusSave", JSON.stringify(newStatus));

      return newStatus;
    });

    //jika localStorage setItem selesai maka saveAnswerRedis();

    setTimeout(() => {
      saveAnswerRedis();
    }, 1000);

    if (isAuto)
      setTimeout(() => {
        handleNextTab();
      }, 1000);
    const payload_log = {
      id_siswa: userData.id_siswa,
      nopes: userData.nopes,
      nama_siswa: userData.nama_siswa,
      id_projek: userData.id_projek,
      type: 'ans',
      url: window.location.href,
      kategori: "Proses Tes",
      sub_kategori: Subtest.nama_projek,
      remaining_time: timerRef.current.getCurrentSeconds,
      keterangan: `${userData.nopes} menjawab soal id ${event.target.title} nomor ${activeTabIndex + 1} dengan response ${event.target.value}`,
      timeStamp: Math.floor(Date.now() / 1000)
    }
    const encryptedPayload_log = encrypt_res(
      JSON.stringify(payload_log),
      SECRET_SESSION
    );
    axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
      data: encryptedPayload_log
    })
  };

  //MCMA
  const [selectedCheckBoxValues, setSelectedCheckBoxValues] = useState({});
  const handleCheckBoxChange = (group, event) => {
    const value = event.target.value;
    setSelectedCheckBoxValues((prevValues) => {
      const newValues = { ...prevValues };

      let val = prevValues[group];

      // Kalau string → buang semua tanda tanya
      if (typeof val === "string") {
        val = val.replace(/\?/g, "");
      }

      // Kalau array → filter elemen yang mengandung tanda tanya
      else if (Array.isArray(val)) {
        val = val.filter(item => typeof item === "string" && !item.includes("?"));
      }

      // Kalau Set → buat Set baru tanpa tanda tanya
      else if (val instanceof Set) {
        val = new Set(
          [...val].filter(item => typeof item === "string" && !item.includes("?"))
        );
      }

      newValues[group] = val;

      // kalau kosong, pastikan jadi Set
      if (!newValues[group] || (Array.isArray(newValues[group]) && newValues[group].length === 0)) {
        newValues[group] = new Set();
      }

      if (newValues[group].has(value + "|1")) {
        newValues[group].delete(value + "|1");
      } else {
        newValues[group].delete(value + "|0");
        newValues[group].add(value + "|1");
      }

      const sortedValues = Array.from(newValues[group]).sort();
      newValues[group] = new Set(sortedValues);

      const waktu_mengerjakan = moment()
        .tz("Asia/Bangkok")
        .format("YYYY-MM-DD HH:mm:ss");

      setWaktuMengerjakan((prevWaktuMengerjakan) => {
        let newStatus = [...prevWaktuMengerjakan];
        newStatus[parseInt(group.replace("jawaban", ""))] = waktu_mengerjakan;
        localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
        return newStatus;
      });

      setIdSoal((prevIdSoal) => {
        let newStatus = [...prevIdSoal];
        newStatus[parseInt(group.replace("jawaban", ""))] = event.target.title;
        localStorage.setItem("idSoal", JSON.stringify(newStatus));
        return newStatus;
      });

      setStatusSave((prevStatusSave) => {
        let newStatus = [...prevStatusSave];
        newStatus[parseInt(group.replace("jawaban", ""))] = 0;
        localStorage.setItem("statusSave", JSON.stringify(newStatus));
        return newStatus;
      });

      setStatusJawaban((prevStatusJawaban) => {
        let newStatus = [...prevStatusJawaban];
        newStatus[parseInt(group.replace("jawaban", ""))] = Array.from(
          newValues[group]
        ).join(";");
        localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
        return newStatus;
      });

      setTimeout(() => {
        saveAnswerRedis();
      }, 1000);
      const payload_log = {
        id_siswa: userData.id_siswa,
        nopes: userData.nopes,
        nama_siswa: userData.nama_siswa,
        id_projek: userData.id_projek,
        type: 'ans',
        url: window.location.href,
        kategori: "Proses Tes",
        sub_kategori: Subtest.nama_projek,
        remaining_time: timerRef.current.getCurrentSeconds,
        keterangan: `${userData.nopes} menjawab soal id ${event.target.title} nomor ${activeTabIndex + 1} dengan response ${Array.from(newValues[group]).join(";")}`,
        timeStamp: Math.floor(Date.now() / 1000)
      }
      const encryptedPayload_log = encrypt_res(
        JSON.stringify(payload_log),
        SECRET_SESSION
      );
      axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
        data: encryptedPayload_log
      })
      return newValues;
    });
  };
  // console.log(DaftarSoal?.listSoal[noSoal - 1]?.subtes2)
  //PG Benar Salah
  const [selected3Values, setSelected3Values] = useState({});
  const handleRadio3Change = (group, count, index) => (event) => {
    setSelected3Values((prevSelectedValues) => ({
      ...prevSelectedValues,
      [group]: parseInt(event.target.value),
    }));

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      const selectedValues = [];
      for (let i = 0; i < count; i++) {
        const radioButtons = document.querySelectorAll(
          'input[name="jawaban-' + index + "-" + i + '"]'
        );

        // alert('input[name="jawaban' + index + "-" + i + '"]');
        // Filter selected radio buttons and extract their values
        selectedValues[i] = Array.from(radioButtons)
          .filter((radio) => radio.checked)
          .reduce((acc, radio) => {
            acc = radio.alt + "|" + radio.value;
            // acc[radio.name] = radio.value; // or acc[radio.id] = radio.value;
            return acc;
          }, "");
      }

      // let newData = Array.from(selectedValues).join(",");
      // alert(newData);
      // alert(selectedValues.join("|"));
      const hasEmpty = selectedValues.some(
        (item) => item === "" || item === null || item === undefined || item.includes("?")
      );

      if (!hasEmpty) {
        newStatus[index] = selectedValues.join(";");

        const waktu_mengerjakan = moment()
          .tz("Asia/Bangkok")
          .format("YYYY-MM-DD HH:mm:ss");

        setWaktuMengerjakan((prevWaktuMengerjakan) => {
          let newStatus2 = [...prevWaktuMengerjakan];
          newStatus2[index] = waktu_mengerjakan;
          localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus2));
          return newStatus2;
        });

        setIdSoal((prevIdSoal) => {
          let newStatus1 = [...prevIdSoal];
          newStatus1[index] = event.target.title;
          localStorage.setItem("idSoal", JSON.stringify(newStatus1));
          return newStatus1;
        });

        setStatusSave((prevStatusSave) => {
          let newStatus3 = [...prevStatusSave];
          newStatus3[index] = 0;
          localStorage.setItem("statusSave", JSON.stringify(newStatus3));
          return newStatus3;
        });

        if (isAuto)
          setTimeout(() => {
            handleNextTab();
          }, 1000);
        // newStatus[parseInt(group.replace("jawaban", "").split("-")[1])] =
        //   selectedValues.join(";");
      } else {
        newStatus[index] = "";
        // newStatus[parseInt(group.replace("jawaban", "").split("-")[1])] = "";
      }

      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));

      setTimeout(() => {
        saveAnswerRedis();
      }, 1000);
      if (newStatus[index].length > 0){
        const payload_log = {
          id_siswa: userData.id_siswa,
          nopes: userData.nopes,
          nama_siswa: userData.nama_siswa,
          id_projek: userData.id_projek,
          type: 'ans',
          url: window.location.href,
          kategori: "Proses Tes",
          sub_kategori: Subtest.nama_projek,
          remaining_time: timerRef.current.getCurrentSeconds,
          keterangan: `${userData.nopes} menjawab soal id ${event.target.title} nomor ${activeTabIndex + 1} dengan response ${newStatus[index]}`,
          timeStamp: Math.floor(Date.now() / 1000)
        }
        const encryptedPayload_log = encrypt_res(
          JSON.stringify(payload_log),
          SECRET_SESSION
        );
        axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
          data: encryptedPayload_log
        })
      }
      return newStatus;
    });
  };

  const handleIsianChange = (event, index) => {
    // const input_box_id = `${group}${id}`;
    const value = event.target.value;
    // console.log(document.querySelectorAll("input").length);
    const id_box = parseInt(event.target.id.substring(2)) - 1;
    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      try {
        var temp = JSON.parse(localStorage.getItem("statusJawaban"))[index].split(";");
      } catch (error) {
        var temp = []
      }
      if (value.length === 0){
        temp[id_box] = ''
      }else {
        temp[id_box] = `${event.target.id}:${value}`
      }
      newStatus[index] = temp.join(";");
      if (newStatus[index] == ';'){
        newStatus[index] = "?";
      }
  
      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
      return newStatus;
    });
    const waktu_mengerjakan = moment()
      .tz('Asia/Bangkok')
      .format("YYYY-MM-DD HH:mm:ss");
    setWaktuMengerjakan((prevWaktuMengerjakan) => {
      let newStatus = [...prevWaktuMengerjakan];
      newStatus[index] = waktu_mengerjakan;
      localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
      return newStatus;
    });
    setIdSoal((prevIdSoal) => {
      let newStatus = [...prevIdSoal];
      newStatus[index] = parseInt(event.target.title);
      localStorage.setItem("idSoal", JSON.stringify(newStatus));
      return newStatus;
    });
    setStatusSave((prevStatusSave) => {
      let newStatus = [...prevStatusSave];
      newStatus[index] = 0;
      localStorage.setItem("statusSave", JSON.stringify(newStatus));
      return newStatus;
    });
    if (debounce_timeout) {clearTimeout(debounce_timeout)};

    debounce_timeout = setTimeout(() => {
      saveAnswerRedis();
      const response = JSON.parse(localStorage.getItem("statusJawaban"))
      const payload_log = {
        id_siswa: userData.id_siswa,
        nopes: userData.nopes,
        nama_siswa: userData.nama_siswa,
        id_projek: userData.id_projek,
        type: 'ans',
        url: window.location.href,
        kategori: "Proses Tes",
        sub_kategori: Subtest.nama_projek,
        remaining_time: timerRef.current.getCurrentSeconds,
        // keterangan: `${userData.nopes} menjawab soal nomor ${activeTabIndex + 1} dengan response ${response[activeTabIndex]}`,
        keterangan: `${userData.nopes} menjawab soal id ${DaftarSoal.listSoal[activeTabIndex].id_soal} nomor ${activeTabIndex + 1} dengan response ${response[activeTabIndex]}`,
        timeStamp: Math.floor(Date.now() / 1000)
      }
      const encryptedPayload_log = encrypt_res(
        JSON.stringify(payload_log),
        SECRET_SESSION
      );
      axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
        data: encryptedPayload_log
      });
    }, 800)
  };
  const attachHandleChange = (group, id, index, soal) => {
    const input_box_id = `${group}${id}`;
    const element = document.getElementById(input_box_id);

    if (element.classList.contains('cpnumber')) {
      element.addEventListener('input', function () {
          // hanya boleh angka, koma, dan titik
          this.value = this.value.replace(/[^0-9.,]/g, '');
      });
      element.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault(); // mencegah submit / aksi enter
        }
      });
    }
    // for recover response
    const all_response = JSON.parse(localStorage.getItem("statusJawaban"))
    
    if (all_response.length > 0){
      const response = all_response[index].split(";");
      if (response[parseInt(id) - 1] && response[parseInt(id) - 1] != "?"){
        element.value = response[parseInt(id) - 1].replace(`${input_box_id}:`, "");
      }
    }
    if (element){
      element.removeEventListener("change", handleIsianChange);
      element.addEventListener("change", (event) => handleIsianChange(event, index));
      element.style.borderWidth = "2px";
      element.style.borderColor = "black";
      element.style.borderRadius = "8px";
      element.title = soal.id_soal;
    }else{
      console.error(`${input_box_id} tidak ada di soal`);
    }
  }

  const handleTextAreaChange = (event, group, maxWords) => {
    const textarea = event.target;
    let value = event.target.value;

    // Hitung kata dan terapkan batasan
    const words = value.trim().split(/\s+/).filter(Boolean);
    let wordCount = words.length;

    // if (wordCount > maxWords) {
    //   value = words.slice(0, maxWords).join(" ");
    //   // Jika Anda ingin memberi tahu pengguna secara langsung (misalnya, dengan alert) bahwa teks telah dipotong,
    //   // Anda bisa menambahkannya di sini. Namun, umpan balik visual di bawah textarea biasanya cukup.
    // }
    
    // Atur tinggi textarea secara dinamis
    textarea.style.height = 'auto'; // Penting: Reset tinggi agar scrollHeight dihitung ulang dengan benar, terutama saat menghapus teks.
    textarea.style.height = `${textarea.scrollHeight}px`; // Set tinggi baru berdasarkan konten.

    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [group]: value,
    }));

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      newStatus[parseInt(group.replace("jawaban", ""))] = value;
      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
      return newStatus;
    });
    const waktu_mengerjakan = moment()
      .tz("Asia/Bangkok")
      .format("YYYY-MM-DD HH:mm:ss");
    setWaktuMengerjakan((prevWaktuMengerjakan) => {
      let newStatus = [...prevWaktuMengerjakan];
      newStatus[parseInt(group.replace("jawaban", ""))] = waktu_mengerjakan;
      localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
      return newStatus;
    });
    setIdSoal((prevIdSoal) => {
      let newStatus = [...prevIdSoal];
      newStatus[parseInt(group.replace("jawaban", ""))] = event.target.title;
      localStorage.setItem("idSoal", JSON.stringify(newStatus));
      return newStatus;
    });
    setStatusSave((prevStatusSave) => {
      let newStatus = [...prevStatusSave];
      newStatus[parseInt(group.replace("jawaban", ""))] = 0;
      localStorage.setItem("statusSave", JSON.stringify(newStatus));
      return newStatus;
    });

    // Start random interval timer (30-40 seconds) if not already running
    if (!textareaAutosaveTimerRef.current) {
      const startRandomTimer = () => {
        // Generate random time between 30-45 seconds (30000-45000ms)
        const randomTime = Math.floor(Math.random() * (45000 - 30000 + 1)) + 30000;
        // const randomTime = 31000;
        textareaAutosaveTimerRef.current = setTimeout(() => {
          saveAnswerRedis();
          // Start next random timer
          const payload_log = {
            id_siswa: userData.id_siswa,
            nopes: userData.nopes,
            nama_siswa: userData.nama_siswa,
            id_projek: userData.id_projek,
            type: 'ans',
            url: window.location.href,
            kategori: "Proses Tes",
            sub_kategori: Subtest.nama_projek,
            remaining_time: timerRef.current.getCurrentSeconds,
            keterangan: `${userData.nopes} menjawab soal id ${event.target.title} nomor ${activeTabIndex + 1} dengan response ${event.target.value.length} karakter. ${event.target.value}`,
            timeStamp: Math.floor(Date.now() / 1000)
          }
          const encryptedPayload_log = encrypt_res(
            JSON.stringify(payload_log),
            SECRET_SESSION
          );
          axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
            data: encryptedPayload_log
          })
          startRandomTimer();
        }, randomTime);
      };
      
      startRandomTimer();
    }

    if (isAuto)
      setTimeout(() => {
        handleNextTab();
      }, 1000);
  };
  
  // state untuk toggle auto next tab
  const [isAuto, setIsAuto] = useState(false);

  const handleToggle = (isOn) => {
    setIsAuto(isOn);
    // Perform actions based on the toggle state
  };

  const handleOpenNavigasiSoal = (status) => {
    setIsVisibleNavigasiSoal(status);
  };

  const fixImagesInParagraphs = (html) => {
    return html.replace(
      /<p([^>]*style\s*=\s*["'][^"']*text-align\s*:\s*(center|justify)[^"']*["'][^>]*)>([\s\S]*?)<\/p>/gi,
      (match, pAttrs, alignType, innerContent) => {
        const updatedContent = innerContent.replace(
          /<img([^>]*?)style="(.*?)"/gi,
          (imgMatch, imgAttrs, imgStyle) => {
            let newStyle = imgStyle;
            if (alignType === 'center' && !imgStyle.includes('display')) {
              newStyle += '; display: block; margin: auto;';
            } else if (alignType === 'justify' && !imgStyle.includes('display')) {
              newStyle += '; display: inline;';
            }
            return `<img${imgAttrs}style="${newStyle}"`;
          }
        );
        return `<p${pAttrs}>${updatedContent}</p>`;
      }
    );
  };

  const scaleSoal = (soal, fontSize) => {
    // return soal;

    // Step 1: Tempel ke DOM virtual
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = soal;

    // Step 2: Hitung skala perbandingan font
    const baseFont = 18; // misalnya 14px adalah ukuran asli referensi
    const scale = fontSize / baseFont;

    // Step 3: Apply style font + line height
    const elements = tempDiv.querySelectorAll('*');
    elements.forEach(element => {
      element.style.fontSize = `${fontSize}px`;
      element.style.lineHeight = `${fontSize * 1.5}px`;
      // element.style.fontFamily = 'Times New Roman';
    });

    // Step 4: Resize gambar berdasarkan skala
    const images = tempDiv.querySelectorAll('img');
    images.forEach(img => {
      const width = img.getAttribute('width');
      const height = img.getAttribute('height');

      if (width && height) {
        const newWidth = parseFloat(width) * scale;
        const newHeight = parseFloat(height) * scale;
        img.setAttribute('width', newWidth.toFixed(2));
        img.setAttribute('height', newHeight.toFixed(2));
      } else {
        // fallback jika tidak ada width/height, gunakan CSS
        img.style.width = `${img.offsetWidth * scale}px`;
        img.style.height = `${img.offsetHeight * scale}px`;
      }
    });

    //step 4:
    tempDiv.innerHTML = fixImagesInParagraphs(tempDiv.innerHTML);

    return tempDiv.innerHTML;
  };

  // Function to check if webcam is available
  // const isWebcamAvailable = async () => {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     stream.getTracks().forEach((track) => track.stop());
  //     return true;
  //   } catch (err) {
  //     return false;
  //   }
  // };

  //kirim gambar ke server setiap 1 menit
  // useEffect(() => {
  //   console.log("interval capture picture");
  //   const checkAndCapture = async () => {
  //     if (dataProjek && dataProjek.kamera != 0) {
  //       const interval2 = setInterval(() => {
  //         let captureImage = headerRef.current.capture();
  //         if (captureImage){
  //           const payload_capture = {
  //             id_projek: userData.id_projek,
  //             id_siswa: userData.id_siswa,
  //             id_ujian: 0,
  //             nopes: userData.nopes,
  //             image: captureImage,
  //             timeStamp: Math.floor(Date.now() / 1000)
  //           }
  //           const encryptedPayload_capture = encrypt_res(
  //             JSON.stringify(payload_capture),
  //             SECRET_SESSION
  //           );
  //           axiosInstance.post(API_URL_PHOTO + "/peserta/save_image", {
  //             data: encryptedPayload_capture
  //           });
  //         }else{
  //           const payload_log = {
  //             id_siswa: userData.id_siswa,
  //             nopes: userData.nopes,
  //             nama_siswa: userData.nama_siswa,
  //             id_projek: userData.id_projek,
  //             type: 'log',
  //             url: window.location.href,
  //             kategori: "Proses Tes",
  //             sub_kategori: "Pindah Subtes",
  //             remaining_time: timerRef.current.getCurrentSeconds,
  //             keterangan: `${userData.nopes} kamera gagal menangkap gambar peserta`,
  //             timeStamp: Math.floor(Date.now() / 1000)
  //           }
  //           const encryptedPayload_log = encrypt_res(
  //             JSON.stringify(payload_log),
  //             SECRET_SESSION
  //           );
  //           axiosInstance.post(API_URL_LOG + "/peserta/post_log", {
  //             data: encryptedPayload_log
  //           })
  //         }
  //       }, 53000); // 1 minute interval
  //       intervalRef.current.push(interval2);
  //       return () => clearInterval(interval2);
  //     }
  //   };
  //   checkAndCapture();

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [dataProjek]);


  if (isLoading) {
    let temp = `/peserta/start_test?username=${userData.username}&event=${userData.id_projek}`
    return <Loader destination={temp}/>;
  }

  return (
    <div className="App" translate="no">
      <PauseModal
        isOpen={isPauseModalOpen}
        title={"Perhatian"}
        subtitle={pesan}
      />

      <PauseModal
        isOpen={isStopModalOpen}
        title={"Perhatian"}
        subtitle={pesan}
      />
      <AlertModal
        isOpen={alertVisible}
        onConfirm={() => setAlertVisible(false)}
        title={"Kesalahan Jaringan"}
        btn_text="Ok."
        subtitle={"Jaringan terganggu. Silakan coba lagi nanti."}
      />
      <MessageModal
        isOpen={isMessageModalOpen}
        title="Pesan Pengawas"
        arrayMessages={pesanPengawas}
        subtitle={pesanPengawas}
        // currentMessageIndex={currentMessageIndex}
        // setCurrentMessageIndex={setCurrentMessageIndex}
        // maxIndex={maxIndex}
        // setMaxIndex={setMaxIndex}
        onConfirm={(input) => {
          axiosInstance
            .post(
              PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/mark-read",
              {
                id_projek: userData.id_projek,
                id_siswa: userData.id_siswa,
                timestamp: timeStamp,
              }
            )
            .then((response) => {
              setModalMessageOpen(false);
            })
            .catch((error) => {
              console.log("Network error pesan jadi tak terbaca");
            });
          // axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/send",
          //   {
          //     id_projek: userData.id_projek,
          //     id_siswa: userData.id_siswa,
          //     nama_siswa: userData.nama_siswa,
          //     text: input
          //   })
          //   .then((response) => {
          //     // console.log(maxIndex);
          //     input = "";
          //     axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/mark-read",
          //       {
          //         id_projek: userData.id_projek,
          //         id_siswa: userData.id_siswa,
          //         timestamp: timeStamp
          //       }
          //     );
          //   })
          //   .catch((error) => {
          //     console.log("Pesan gagal dikirim");
          //   });
          setModalMessageOpen(false);
        }}
      />

      <ConfirmationModal
        isOpen={isModalOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        btn_cancel="Kembali"
        title={"Konfirmasi Selesai Subtes"}
        showChecked={true}
        subtitle={
          Subtest && Subtest.urut < Subtest.jumlah_subtest ? (
            <>
              Jawaban Anda sudah tersimpan. Apakah Anda yakin akan melanjutkan ke subtes berikutnya?
              {countEmpty > 0 && (
                <> <strong>Terdapat {countEmpty} soal yang masih belum terjawab.</strong></>
              )}
            </>
          ) : (
            <>
              Apakah Anda yakin akan <strong>menyelesaikan ujian?</strong>
              {countEmpty > 0 && (
                <> Terdapat <strong>{countEmpty} soal</strong> yang masih belum terjawab.</>
              )}
            </>
          )
        }
        check_text={
          Subtest && Subtest.urut < Subtest.jumlah_subtest ? ("Ya, Saya yakin akan melanjutkan") : ("Ya, Saya yakin akan menyelesaikan")
        }
        btn_text={
          Subtest && Subtest.urut < Subtest.jumlah_subtest ? ("Lanjutkan") : ("Selesai")
        }
        isArrow={
          Subtest && Subtest.urut < Subtest.jumlah_subtest ? (true) : (false)
        }
      />

      <AlertModal
        isOpen={isAlertModalOpen}
        onConfirm={handleCancel}
        title={"Konfirmasi Selesai Subtes"}
        subtitle={
          <>
            Silahkan lengkapi jawaban Anda terlebih dahulu sebelum menyelesaikan subtes. Terdapat <strong>{countEmpty} soal</strong> yang masih belum terjawab.
          </>
        }
      />

      <AlertModal
        isOpen={isAlertTimeModalOpen}
        onConfirm={handleCancel}
        title={"Perhatian"}
        btn_text="Kembali"
        subtitle={
          <>
            Anda baru dapat melanjutkan ke subtest berikutnya setelah <strong>{sisaTunggu} menit</strong>. Silahkan cek kembali jawaban Anda.
          </>
        }
      />

      <AlertProgres
        isOpen={isAlertProgresOpen}
        title={"Sedang diproses ..."}
        subtitle={""}
      />

      <AlertModal
        isOpen={isAlertTimeOutOpen}
        onConfirm={handleConfirm}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Waktu tes anda sudah habis, silahkan klik tombol untuk menyelesaikan subtes."
        }
      />

      <NoCopyText>
        <div
          className="App-header overflow-y-hidden"
        >
          <Header2 app_name={post && post.alamat} camera={dataProjek && dataProjek.kamera != 0} mobile = {isMobile} ref={headerRef}/>
          <div
            className="md:flex flex-row w-full gap-5 lg:px-[100px] sm:px-5"
            style={{
              marginTop: "90px",
              // "margin-top": "10px",
              // marginBottom: "100px",
            }}
          >
            <div
              className={
                "login-container w-full  z-10 bg-none sm:bg-white border-0 sm:border-2 border-grey-800 rounded-xl shadow-xl p-5"
              }
              style={{
                minHeight: "200px",
              }}
            >
              <div className={!isVisibleNavigasiSoal ? "flex w-full lg:flex-row sm:flex-col flex-wrap gap-1": "flex w-full lg:flex-row sm:flex-col flex-nowrap gap-1"}>
                {/* Kolom Kiri */}
                <div className="flex-grow p-4">
                    <div className="flex justify-between pt-1 mb-2 items-center  rounded rounded-lg">
                      <div className="flex flex-row gap-4 items-center justify-between">
                        {isMobile ? (
                          <div>
                            {/* <div>
                              {DaftarSoal?.listSoal[noSoal - 1]?.subtes1 ? (
                                <div
                                  className="relative max-w-10 truncate overflow-hidden whitespace-nowrap"
                                  style={{
                                    fontFamily: '"Poppins", sans-serif',
                                    fontWeight: 600,
                                    fontSize: "10px",
                                    maxWidth: "auto",
                                  }}
                                >
                                  {DaftarSoal.listSoal[noSoal - 1].subtes1}
                                </div>
                              ): null}
                              </div>
                              <div>
                              {DaftarSoal?.listSoal[noSoal - 1]?.subtes2 && DaftarSoal?.listSoal[noSoal - 1]?.subtes2 != "null"
                                ? (<div
                                  className="relative text-xs truncate overflow-hidden whitespace-nowrap"
                                  style={{
                                    fontFamily: '"Poppins", sans-serif',
                                    fontWeight: 300,
                                    maxWidth: "120px"
                                  }}
                                >
                                  {DaftarSoal.listSoal[noSoal - 1].subtes2}
                                </div>)
                                : null}
                              </div> */}
                          </div>
                        ) : 
                        <div className="mt-1 min-w-[50px] font-bold">
                            Soal Nomor {noSoal && noSoal}
                        </div>}
                        {isMobile ? (
                          <div className="text-sm">
                          <div className="flex flex-row items-center justify-center space-x-4">
                          <div className="mt-1 min-w-[50px] font-bold">
                            Soal Nomor {noSoal && noSoal}
                          </div>
                          <div className="text-sm mt-1 min-w-[120px] text-center flex flex-row gap-2"> {/* Tambahkan gap-2 agar ada jarak antar ikon */}
                            <PiMagnifyingGlassPlus
                              onClick={increaseFontSize}
                              className="text-xl cursor-pointer"  /> 
                            <PiMagnifyingGlassMinus
                              onClick={decreaseFontSize}
                              className="text-xl cursor-pointer" /> 
                          </div>
                            
                            {/* Tombol Panah Kiri */}
                            {/* <button
                              onClick={goToPreviousPage}
                              disabled={currentPage === 0}
                              className="px-2 py-1 rounded bg-gray-300 disabled:opacity-50"
                            >
                              &#8592;
                            </button> */}
                        
                            {/* Tombol Soal */}
                            {/* <div className="flex flex-row flex-wrap justify-center">
                              {currentSoalList && currentSoalList.map((soal, index) => {
                                const actualIndex = startIndex + index;
                                return (
                                  <div className="relative inline-block" key={actualIndex}>
                                    <button
                                      type="button"
                                      onClick={setTab.bind(this, actualIndex)}
                                      disabled={isBtnNavigasiEnabled}
                                      className={
                                        activeTabIndex === actualIndex
                                          ? "bg-[#01B224] border-1 border-blue-400 hover:bg-blue-200 py-1 px-2 rounded m-1 text-white text-xs"
                                          : statusJawaban[actualIndex] && statusJawaban[actualIndex] !== "?"
                                          ? "bg-[#2D7DBE] border border-gray-200 hover:bg-gray-400 py-1 px-2 rounded m-1 text-white text-xs"
                                          : "bg-[#F3F3F3] border border-gray-200 hover:bg-gray-400 py-1 px-2 rounded m-1 text-[#C9C9C9] text-xs"
                                      }
                                      style={{ width: "30px", height: "30px" }}
                                    >
                                      {actualIndex + 1}
                                    </button>
                                  </div>
                                );
                              })}
                            </div> */}
                        
                            {/* Tombol Panah Kanan */}
                            {/* <button
                              onClick={goToNextPage}
                              disabled={currentPage >= totalPages - 1}
                              className="px-2 py-1 rounded bg-gray-300 disabled:opacity-50"
                            >
                              &#8594;
                            </button> */}
                          </div>
                        </div>
                        
                        ): (
                          <div className="text-sm mt-1 min-w-[120px] text-center flex flex-row gap-2"> {/* Tambahkan gap-2 agar ada jarak antar ikon */}
                            <PiMagnifyingGlassPlus
                              onClick={increaseFontSize}
                              className="text-xl cursor-pointer"  /> 
                            <PiMagnifyingGlassMinus
                              onClick={decreaseFontSize}
                              className="text-xl cursor-pointer" /> 
                          </div>
                        )}
                        
                      </div>
                      <div className="flex flex-row items-center justify-between gap-2 p-1 mr-1 border border-red-500 rounded rounded-xl">
                            <PiClock />
                            {Subtest && (
                              <CountdownTimer
                                status={starTimer}
                                ref={timerRef}
                                initialSeconds={Subtest.sisa_waktu}
                                // initialSeconds={3600}
                                onTime={() => handleOpenModalTimeout()}
                              />
                            )}
                      </div>
                    </div>
                    <form>
                      <div
                        className="contentSoal border-2 border-gray-200 rounded-md p-4 z-1 custom-height-soal"
                        style={{ minHeight: "400px" }}
                      >
                        {DaftarSoal ? (
                          <div
                            className="flex flex-row flex-wrap"
                            style={
                              { fontSize: `${fontSize}px`, 
                              fontFamily: 'Times New Roman' 
                            }
                            }
                            // style={{ transform: 'scale(1.25)', transformOrigin: '' }}
                            // style={{ '--font-scale': 1.5 }}
                          >
                            <QuestionItem 
                              soal={DaftarSoal.listSoal[activeTabIndex]}
                              index={activeTabIndex}
                              fontSize={fontSize}
                              selectedValues={selectedValues}
                              selectedCheckBoxValues={selectedCheckBoxValues}
                              selected3Values={selected3Values}
                              statusJawaban={statusJawaban}
                              handleRadioChange={handleRadioChange}
                              handleRadio3Change={handleRadio3Change}
                              handleCheckBoxChange={handleCheckBoxChange}
                              handleTextAreaChange={handleTextAreaChange}
                              parseHtml={parseHtml}
                              scaleSoal={scaleSoal}
                              attachHandleChange={attachHandleChange}
                            />
                          </div>
                        ) : (
                          <Loading />
                        )}
                      </div>
                    </form>
                    {isVisible && (
                      <div className="flex justify-between pt-2 ">
                        <button
                          type="button"
                          id="btn-previous"
                          onClick={handlePreviousTab}
                          disabled={activeTabIndex === 0 || isBtnNavigasiEnabled}
                          className="flex items-center bg-red-500 hover:bg-red-800 text-white py-2 px-4 rounded-2xl h-10 mt-1 "
                        >
                          <PiCaretLeftBold />
                          <span className="pl-2">Soal Sebelumnya</span>
                        </button>

                        <button
                          type="button"
                          id="btn-previous"
                          disabled={isBtnNavigasiEnabled}
                          onClick={
                            DaftarSoal &&
                            activeTabIndex === DaftarSoal.listSoal.length - 1
                              ? handleFinishTest
                              : handleNextTab
                          }
                          // disabled={
                          //   DaftarSoal &&
                          //   activeTabIndex === DaftarSoal.listSoal.length - 1
                          // }
                          className="flex items-center backgroundColor hover:bg-teal-600 text-white py-2 px-4 rounded-2xl h-10 mt-1 btn-navigasi"
                        >
                          <span className="pr-2">
                            {DaftarSoal &&
                            activeTabIndex === DaftarSoal.listSoal.length - 1
                              ? "Selesai Subtes"
                              : "Soal Selanjutnya"}
                          </span>
                          {DaftarSoal &&
                          activeTabIndex === DaftarSoal.listSoal.length - 1 ? (
                            ''
                          ) : (
                            <PiCaretRightBold />
                          )}
                        </button>
                      </div>
                    )}
                </div>
                {/* Kolom Kanan */}
                <div
                  className={
                    isVisibleNavigasiSoal
                      ? isMobile
                        ? "fixed right-0 top-0 h-full w-4/5 bg-white z-50 p-4 overflow-auto shadow-lg transform translate-x-0 transition-transform duration-300 ease-in-out" // modal kanan
                        : "w-full lg:w-1/6 md:min-w-[300px]" // desktop
                      : isMobile
                        ? "fixed right-0 top-0 h-full hidden w-1/2 bg-white z-50 p-4 overflow-auto shadow-lg transform translate-x-full transition-transform duration-300 ease-in-out" // posisi tersembunyi
                        : "translate-x-full hidden w-full lg:w-1/6 p-4 md:min-w-[300px]" // desktop tersembunyi
                  }
                >{/* w-1/4 membuat kolom kanan mengambil 1/4 lebar total */}
                    <div className="border border-muted p-3 rounded-lg flex flex-row items-center backgroundColor mb-2 gap-4s shadow" >
                      {/* {Subtest && parseHtml(Subtest.nama_projek)} */}
                      <div className="flex flex-col">
                        <div>
                          {DaftarSoal?.listSoal[noSoal - 1].subtes1 && parseHtml(DaftarSoal.listSoal[noSoal - 1].subtes1)}
                        </div>
                        {/* <div>
                        {DaftarSoal?.listSoal[noSoal - 1]?.subtes2 
                          ? parseHtml(DaftarSoal.listSoal[noSoal - 1].subtes2)
                          : parseHtml("TIDAK ADA")}
                        </div> */}
                      </div>
                      <div className="h-full ml-auto flex items-center justify-center">
                        <PiCaretRightBold className="cursor-pointer" onClick={() => handleOpenNavigasiSoal(false)} />
                      </div>
                    </div>
                    <div className="border border-muted rounded-lg items-center  mb-4 shadow py-4 px-2 contentSoal custom-height-soal lg:min-h-[395px]">
                      <div className="relative flex flex-row gap-1 justify-between py-2 px-2 items-center w-full">
                        <div className="text-sm font-bold ml-4">DAFTAR SOAL </div>
                        {/* <div className="group inline-block">
                          <Toggle onToggle={handleToggle} />
                          <div className="absolute bottom-[70%] mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-0 px-2">
                            Pindah Soal Otomatis
                          </div>
                        </div> */}
                        <div className="mr-4">
                          <InfoStatusJawab />
                        </div>
                      </div>
                      
                      {DaftarSoal ? (
                        <div className="text-sm">
                          <div className="flex flex-row justify-center flex-wrap">
                            {DaftarSoal.listSoal.map((soal, index) => (
                              <div className="relative inline-block" key={index}>
                                <div className="m-0 rounded-lg">
                                  <button
                                    key={index}
                                    type="button"
                                    onClick={setTab.bind(this, index)}
                                    disabled={isBtnNavigasiEnabled}
                                    className={
                                      activeTabIndex === index
                                        ? "bg-[#01B224] border-1 border-blue-400 hover:bg-blue-200 py-2 px-2 rounded m-1 text-white" // aktif
                                        : statusJawaban[index] && statusJawaban[index] != "?" ? (
                                          "bg-[#2D7DBE] border border-gray-200 hover:bg-gray-400 py-2 px-2 rounded m-1 text-white" // sudah dijawab
                                        ) : (
                                          "bg-[#F3F3F3] border border-gray-200 hover:bg-gray-400 py-2 px-2 rounded m-1 text-[#C9C9C9]" // belum dijawab 
                                        )
                                    }
                                    style={{ width: "40px" }}
                                  >
                                    {index + 1}
                                  </button>
                                  {/* {statusJawaban[index] && statusJawaban[index] != "?" &&(
                                    <span
                                      className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-sm font-medium text-white bg-green-500 rounded-full"
                                      style={{ transform: "translate(10%, -10%)" }}
                                    >
                                      <FaCheck className="w-2" />
                                    </span>
                                  )} */}
                                </div>
                              </div>

                              // <div>
                              //   <button
                              //     key={index}
                              //     type="button"
                              //     onClick={setTab.bind(this, index)}
                              //     className={
                              //       activeTabIndex === index
                              //         ? "bg-blue-500 border-2 border-blue-400 hover:bg-blue-200 py-2 px-2 rounded m-1"
                              //         : "bg-white-500 border-2 border-gray-200 hover:bg-gray-400 py-2 px-2 rounded m-1"
                              //     }
                              //     style={{ width: "40px" }}
                              //   >
                              //     {index + 1}
                              //   </button>
                              // </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <Loading />
                      )}
                    </div>
                </div>
                {!isVisibleNavigasiSoal && (
                  <div className="absolute top-20 -right-[40px]  rotate-90  p-1 text-sm font-bold bg-green-500 text-white rounded-b-lg shadow cursor-pointer z-10" onClick={() => handleOpenNavigasiSoal(true)}>
                      <div className="flex justify-end items-center gap-2">
                          Daftar Soal <PiGridNine />
                      </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {!isMobile && (
            <div className="text-xs text-gray-500 mt-2 text-center">
              Build {BUILD_VERSION} mobile
            </div>
          )}
        </div>
      </NoCopyText>
    </div>
  );
}

const QuestionItem = React.memo(({ soal, index, activeTabIndex, fontSize, selectedValues, selectedCheckBoxValues, selected3Values, statusJawaban, handleRadioChange,handleRadio3Change, handleCheckBoxChange, handleTextAreaChange, parseHtml, scaleSoal, attachHandleChange }) => {
  // Component implementation
  // if (!soal) return null;
  useEffect(() => {
    if (parseInt(soal.jenis_soal) === 5){
      const n_input = (soal['soal'].match(/input/g) || []).length;
      
      for (var i = 1; i <= n_input; i++){
        attachHandleChange("cp", i, index, soal);
      }
    }
  }, [index])
  return (
  <div
      key={index}
      label={index + 1}
      // className={
      //   activeTabIndex === index ? "w-full" : "hidden"
      // }
    >
      <div>{soal.soal && parseHtml(scaleSoal(soal.soal, fontSize))}</div>

      <div>
        {soal.pertanyaan && parseHtml(scaleSoal(soal.pertanyaan))}
      </div>
      {/* pilihan ganda */}
      {parseInt(soal.jenis_soal) === 1 && (
        <div
          className={
            soal.tampilan_opsi &&
            parseInt(soal.tampilan_opsi) === 1
              ? "flex-col items-center mt-4"
              : "grid grid-cols-1 gap-1"
          }
        >
          {soal.jumlah_opsi >= 1 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <div className="flex flex-row items-center justify-left">
                <input
                  type="radio"
                  className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                  name={"jawaban" + index}
                  value="A"
                  title={soal.id_soal}
                  defaultChecked={
                    selectedValues["jawaban" + index] === "A"
                  }
                  onChange={(e) =>
                    handleRadioChange(e, "jawaban" + index)
                  }
                  onKeyDown={(e) => {
                    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }
                  }
                />
              </div> 
              <span>
                {soal.opsi_a &&
                  parseHtml(
                    scaleSoal(soal.opsi_a.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ), fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 2 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <div className="flex flex-row items-center justify-left">
                <input
                  type="radio"
                  className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                  name={"jawaban" + index}
                  alt={index}
                  value="B"
                  title={soal.id_soal}
                  id={"jawaban" + index + "-B"}
                  defaultChecked={
                    selectedValues["jawaban" + index] === "B"
                  }
                  onChange={(e) =>
                    handleRadioChange(e, "jawaban" + index)
                  }
                  onKeyDown={(e) => {
                    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }
                  }
                />
              </div>
              
              <span>
                {soal.opsi_b &&
                  parseHtml(
                    scaleSoal(soal.opsi_b.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ), fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 3 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <div className="flex flex-row items-center justify-left">
                <input
                  type="radio"
                  className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                  name={"jawaban" + index}
                  alt={index}
                  value="C"
                  title={soal.id_soal}
                  id={"jawaban" + index + "-C"}
                  defaultChecked={
                    selectedValues["jawaban" + index] === "C"
                  }
                  onChange={(e) =>
                    handleRadioChange(e, "jawaban" + index)
                  }
                  onKeyDown={(e) => {
                    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }
                  }
                />
              </div>
              <span>
                {soal.opsi_c &&
                  parseHtml(
                    scaleSoal(soal.opsi_c.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ), fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 4 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <div className="flex flex-row items-center justify-left">
                <input
                  type="radio"
                  className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                  name={"jawaban" + index}
                  alt={index}
                  value="D"
                  title={soal.id_soal}
                  id={"jawaban" + index + "-D"}
                  defaultChecked={
                    selectedValues["jawaban" + index] === "D"
                  }
                  onChange={(e) =>
                    handleRadioChange(e, "jawaban" + index)
                  }
                  onKeyDown={(e) => {
                    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }
                  }
                />
              </div>
              <span>
                {soal.opsi_d &&
                  parseHtml(
                    scaleSoal(soal.opsi_d.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ), fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 5 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <div className="flex flex-row items-center justify-left">
                <input
                  type="radio"
                  className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                  name={"jawaban" + index}
                  alt={index}
                  value="E"
                  title={soal.id_soal}
                  id={"jawaban" + index + "-E"}
                  defaultChecked={
                    selectedValues["jawaban" + index] === "E"
                  }
                  onChange={(e) =>
                    handleRadioChange(e, "jawaban" + index)
                  }
                  onKeyDown={(e) => {
                    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }
                  }
                />
              </div>
              <span>
                {soal.opsi_e &&
                  parseHtml(
                    scaleSoal(soal.opsi_e.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ), fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 6 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <input
                type="radio"
                className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                name={"jawaban" + index}
                alt={index}
                value="F"
                title={soal.id_soal}
                id={"jawaban" + index + "-F"}
                defaultChecked={
                  selectedValues["jawaban" + index] === "F"
                }
                onChange={(e) =>
                  handleRadioChange(e, "jawaban" + index)
                }
                onKeyDown={(e) => {
                  if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                    e.preventDefault();
                  }
                }
                }
              />
              <span>
                {soal.opsi_f &&
                  parseHtml(
                    scaleSoal(soal.opsi_f.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ), fontSize)
                  )}
              </span>
            </label>
          )}

          {/* <p>Selected Values:</p>
        <p>
          Group {index}: {selectedValues["jawaban" + index]}
        </p> */}
        </div>
      )}
      {/* pilihan ganda multijawaban */}
      {parseInt(soal.jenis_soal) === 2 && (
        <div
          className={
            soal.tampilan_opsi &&
            parseInt(soal.tampilan_opsi) === 1
              ? "flex-col items-center mt-4"
              : "grid grid-cols-1 gap-1"
          }
        >
          {soal.jumlah_opsi >= 1 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <span>
              <input
                type="checkbox"
                className="form-checkbox h-[20px] w-[20px] w-[20px] checked:border-indigo-500 mr-2"
                name={"jawaban" + index}
                id={"jawaban" + index}
                alt={index}
                value={"A"}
                title={soal.id_soal}
                checked={
                  selectedCheckBoxValues[
                    "jawaban" + index
                  ]?.has("A|1") || false
                }
                onChange={(event) =>
                  handleCheckBoxChange(
                    "jawaban" + index,
                    event
                  )
                }
              />
              </span>
              <span>
                {soal.opsi_a &&
                  parseHtml(
                    scaleSoal(soal.opsi_a.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ), fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 2 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <span>
              <input
                type="checkbox"
                className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                name={"jawaban" + index}
                id={"jawaban" + index}
                alt={index}
                value={"B"}
                title={soal.id_soal}
                checked={
                  selectedCheckBoxValues[
                    "jawaban" + index
                  ]?.has("B|1") || false
                }
                onChange={(event) =>
                  handleCheckBoxChange(
                    "jawaban" + index,
                    event
                  )
                }
              />
              </span>
              <span>
                {soal.opsi_b &&
                  parseHtml(
                    scaleSoal(soal.opsi_b.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ), fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 3 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <span>
              <input
                type="checkbox"
                className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                name={"jawaban" + index}
                id={"jawaban" + index}
                alt={index}
                value={"C"}
                title={soal.id_soal}
                checked={
                  selectedCheckBoxValues[
                    "jawaban" + index
                  ]?.has("C|1") || false
                }
                onChange={(event) =>
                  handleCheckBoxChange(
                    "jawaban" + index,
                    event
                  )
                }
              />
              </span>
              <span>
                {soal.opsi_c &&
                  parseHtml(
                    scaleSoal(soal.opsi_c.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ),fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 4 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <span>
              <input
                type="checkbox"
                className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                name={"jawaban" + index}
                id={"jawaban" + index}
                alt={index}
                value={"D"}
                title={soal.id_soal}
                checked={
                  selectedCheckBoxValues[
                    "jawaban" + index
                  ]?.has("D|1") || false
                }
                onChange={(event) =>
                  handleCheckBoxChange(
                    "jawaban" + index,
                    event
                  )
                }
              />
              </span>
              <span>
                {soal.opsi_d &&
                  parseHtml(
                    scaleSoal(soal.opsi_d.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ),fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 5 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <span>
              <input
                type="checkbox"
                className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                name={"jawaban" + index}
                id={"jawaban" + index}
                alt={index}
                value={"E"}
                title={soal.id_soal}
                checked={
                  selectedCheckBoxValues[
                    "jawaban" + index
                  ]?.has("E|1") || false
                }
                onChange={(event) =>
                  handleCheckBoxChange(
                    "jawaban" + index,
                    event
                  )
                }
              />
              </span>
              <span>
                {soal.opsi_e &&
                  parseHtml(
                    scaleSoal(soal.opsi_e.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ),fontSize)
                  )}
              </span>
            </label>
          )}
          {soal.jumlah_opsi >= 6 && (
            <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
              <span>
              <input
                type="checkbox"
                className="form-checkbox h-[20px] w-[20px] checked:border-indigo-500 mr-2"
                name={"jawaban" + index}
                id={"jawaban" + index}
                alt={index}
                value={"F"}
                title={soal.id_soal}
                checked={
                  selectedCheckBoxValues[
                    "jawaban" + index
                  ]?.has("F|1") || false
                }
                onChange={(event) =>
                  handleCheckBoxChange(
                    "jawaban" + index,
                    event
                  )
                }
              />
              </span>
              <span>
                {soal.opsi_f &&
                  parseHtml(
                    scaleSoal(soal.opsi_f.replace(
                      /<\?xml[^>]*>|<\/?p>/gm,
                      ""
                    ),fontSize)
                  )}
              </span>
            </label>
          )}
          {/* <p>Selected Values:</p>
        <p>
          Group {index}:{" "}
          {selectedCheckBoxValues["jawaban" + index] &&
            Array.from(
              selectedCheckBoxValues["jawaban" + index]
            ).join(";")}
        </p> */}
        </div>
      )}

      {/* pilihan ganda benar salah/matriks */} 
      {parseInt(soal.jenis_soal) === 3 && (
        <div className="grid grid-cols-1 gap-1">
          <table className="min-w-full bg-white border border-gray-300 rounded">
            <thead>
              <tr className="bg-gray-200 text-gray-700">
                <th className="py-2 px-4 border-b w-10">
                  No.
                </th>
                <th className="py-2 px-4 border-b text-left">
                  {scaleSoal(soal.listAnswerText?.[0]?.judul, fontSize) ??
                    "Pernyataan"}
                </th>
                {soal.listAnswerText[0].listAnswer.map(
                  (item, index2) => (
                    <th className="py-2 px-4 border-b text-center w-40">
                      {item.description}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {soal.listAnswerText.map((item, index2) => (
                <tr
                  key={item.id}
                  className="hover:bg-gray-100"
                >
                  <td className="py-2 px-4 border text-center">
                    {item.group_soal + 1}.
                  </td>
                  <td className="py-2 px-4 border">
                    {parseHtml(
                      // scaleSoal(item.text.replace(/<[^>]*>?/gm, ""), fontSize)
                      item.text
                    )}
                  </td>
                  {item.listAnswer.map((answer, index3) => (
                    <td className="py-2 px-4 border text-center">
                      <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 pt-2 rounded px-[50px]">
                        <input
                          type="radio"
                          // name={`soal-${item.id}`}
                          // value={answer.id}
                          className="form-radio h-5 w-5 checked:border-indigo-500"
                          name={
                            "jawaban-" +
                            index +
                            "-" +
                            index2
                          }
                          alt={item.id_butir}
                          title={soal.id_soal}
                          value={index3}
                          // checked={
                          //   selected3Values[
                          //     "jawaban-" +
                          //       index +
                          //       "-" +
                          //       index2
                          //   ] === index3
                          // }
                          checked={
                            selected3Values[
                              item.id_butir
                            ] === index3
                          }
                          onChange={handleRadio3Change(
                            item.id_butir,
                            soal.listAnswerText.length,
                            index
                          )}
                          onKeyDown={(e) => {
                            if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }
                          }
                        />
                        {/* {selected3Values[
                        "jawaban-" + index + "-" + index2
                      ] + index3} */}
                      </label>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          {/* <p>Selected Values:</p>
        <p>
          Group {index}: {statusJawaban[index]}
        </p> */}
        </div>
      )}
      {/* essai  */}
      {parseInt(soal.jenis_soal) === 4 && (
        <div
        // className={
        //   soal.tampilan_opsi &&
        //   parseInt(soal.tampilan_opsi) === 1
        //     ? "flex items-center mt-4" // Ini sepertinya tidak relevan untuk textarea, mungkin sisa copy-paste
        //     : "grid grid-cols-1 gap-1"
        // }
          className={
            soal.tampilan_opsi &&
            parseInt(soal.tampilan_opsi) === 1
              ? "flex-col items-center mt-4"
              : "grid grid-cols-1 gap-1"
          }
        >
          {(() => {
            const currentText = selectedValues["jawaban" + index] || '';
            const currentWordsArray = currentText.trim().split(/\s+/).filter(Boolean);
            const currentWordCount = currentWordsArray.length;
            const maxWordsForThisSoal = soal.max_kata || 700; // Ambil dari soal atau default 700

            return (
              <>
          <textarea
            className="lg:max-h-[400px] form-textarea w-full p-2 border border-slate-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500" // Menghapus h-32
            name={"jawaban" + index}
            id={"jawaban" + index}
            title={soal.id_soal}
            value={selectedValues["jawaban" + index] || ''}
            onChange={(e) =>
              handleTextAreaChange(e, "jawaban" + index, maxWordsForThisSoal)
            }
            onPaste={(e) => {
              e.preventDefault();
            }}
            onKeyDown={(e) => {
              if (e.key == 'Tab'){
                e.preventDefault();
              }
            }}
            rows="10" // Mulai dengan tinggi untuk 1 baris teks
            placeholder="Tulis jawaban Anda di sini..."
            autoFocus={activeTabIndex === index}
          />
                <div className={`text-right mt-1 text-xs ${currentWordCount > maxWordsForThisSoal ? 'text-red-600 font-semibold' : 'text-gray-500'}`}>
                  {currentWordCount}/{maxWordsForThisSoal} kata
                  {currentWordCount >= maxWordsForThisSoal && <span className="text-red-600 font-semibold"> kata (Batas maksimum tercapai)</span>}
                </div>
              </>
            );
          })()}
        </div>
      )}
    </div>
  );
});

export default ProsesTestReguler;
